<script>
import { defineComponent, markRaw, nextTick, onMounted, ref } from "vue";
import { InjectionKeys, Functions, Utilities } from "@vue-leaflet/vue-leaflet";
import DynamicMapLayer from "esri-leaflet/src/Layers/DynamicMapLayer";
import {
  eDynamicMapLayerProps,
  setupEDynamicMapLayer,
} from "./functions/eDynamicMapLayer";

const { setupTileLayer, tileLayerProps } = Functions.TileLayer;
const { AddLayerInjection } = InjectionKeys;
const { assertInject, propsBinder, remapEvents } = Utilities;

/**
 * Render and visualize MapServices from ArcGIS Enterprise.
 */
export default defineComponent({
  name: "EDynamicMapLayer",
  props: {
    ...eDynamicMapLayerProps,
  },
  setup(props, context) {
    const leafletObject = ref();

    // functions
    const dynamicMapLayerMethods = {};

    const addLayer = assertInject(AddLayerInjection);

    const { options, methods } = setupEDynamicMapLayer(
      props,
      leafletObject,
      context
    );

    // lifecycle
    onMounted(async () => {
      leafletObject.value = markRaw(
        DynamicMapLayer({
          url: props.url,
          updateInterval: props.updateInterval,
          layers: props.layers,
          layerDefs: props.layerDefs,
          format: props.format,
          transparent: props.transparent,
          f: props.f,
          opacity: props.opacity,
          position: props.position,
          cors: props.useCors,
          attribution: props.attribution,
          interactive: props.interactive,
          alt: props.alt,
          to: props.to,
          from: props.from,
        })
      );
      const { listeners } = remapEvents(context.attrs);
      leafletObject.value.on(listeners);

      propsBinder(methods, leafletObject.value, props);

      addLayer({
        ...props,
        ...methods,
        leafletObject: leafletObject.value,
      });

      await nextTick(() => context.emit("ready", leafletObject.value));
    });

    return { leafletObject };
  },
  render() {
    return null;
  },
});
</script>
